import React, { FC, useCallback, useMemo, useState } from 'react';
import AuthLayout from './AuthLayout';
import { useTranslation } from 'react-i18next';
import Form from '@sezenta/antd-schema-form';
import { Button, Input, Modal } from 'antd';
import { useConnection } from '@sezenta/connection';
import { useNavigate } from 'react-router-dom';
import GoogleLoginButton from './GoogleLoginButton';

export const ForgetPassword: FC = () => {
  const { t } = useTranslation();
  const connection = useConnection();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // const schema = useMemo(() => {
  //   return [
  //     {
  //       id: 'email',
  //       name: `${t('forgetPw.email')}`,
  //       type: 'string',
  //       props: {
  //         placeholder: `${t('forgetPw.placeholder.email')}`,
  //       },
  //       options: {
  //         rules: [
  //           {
  //             required: true,
  //             message: `${t('forgetPw.required.email')}`,
  //           },
  //         ],
  //       },
  //     },
  //   ];
  // }, [t]);

  const onSubmit = useCallback(
    (data: any) => {
      setLoading(true);
      connection
        .post('auth/forget-password', data)
        .then((v) => {
          Modal.success({
            title: 'Email Sent',
            content:
              'Instructions to recover your account have been sent to your email.',
            onOk: () => navigate('/login'),
          });
        })
        .catch((e) => {
          console.log('EEEEEEEEEEEE', e.response);
          Modal.error({ title: 'Error', content: e.response.data.message });
        })
        .finally(() => {
          setLoading(false);
          form.resetFields();
        });
    },
    [connection, form, navigate],
  );
  return (
    <div
      className="login-form grid place-items-center h-screen w-screen bg-top"
      style={{ backgroundImage: "url('/img/zig-zag2.png')" }}
    >
      <div
        className="bg-white rounded-[45px] w-[770px] h-[560px] flex p-4"
        style={{ boxShadow: '0px 6px 28px 2px rgba(0, 0, 0, 0.12)' }}
      >
        <div className="flex flex-col w-[60%] h-full items-center py-6 px-6 pl-3">
          <h1 className="text-3xl font-semibold mb-4">Reset Password</h1>
          <p className="text-gray-500">
            Enter your email to get Password reset link
          </p>
          <Form
            form={form}
            name="login"
            className="flex flex-col w-full gap-2 mt-6"
            onFinish={onSubmit}
          >
            <div>
              <label>Email Address</label>
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Invalid email format!' },
                ]}
              >
                <Input placeholder="Email Address" />
              </Form.Item>
            </div>
            {/*<div className="mt-1">*/}
            {/*  <div className="flex justify-between">*/}
            {/*    <label>Password</label>*/}
            {/*    <a*/}
            {/*      href="/forget-password"*/}
            {/*      className="text-primary-base font-semibold no-underline"*/}
            {/*    >*/}
            {/*      Forgot Password*/}
            {/*    </a>*/}
            {/*  </div>*/}
            {/*  <Form.Item*/}
            {/*    name="password"*/}
            {/*    rules={[*/}
            {/*      { required: true, message: 'Please input your password!' },*/}
            {/*    ]}*/}
            {/*  >*/}
            {/*    <Input.Password placeholder="Password" />*/}
            {/*  </Form.Item>*/}
            {/*</div>*/}
            <div className="flex flex-col mt-0">
              <Form.Item>
                <Button
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                  className="w-full mt-1"
                  style={{
                    height: '50px',
                    borderRadius: '12px',
                    fontSize: '20px',
                  }}
                >
                  Reset Password
                </Button>
              </Form.Item>
            </div>
            {/*<p className="flex items-center justify-center mt-1 gap-1">*/}
            {/*  <span className="w-[40px] border border-gray-300 border-solid"></span>*/}
            {/*  <span className="text-gray-500 ml-1">or Login with</span>*/}
            {/*  <span className="w-[40px] border border-gray-300 mt-1 border-solid ml-[4px]"></span>*/}
            {/*</p>*/}
            {/*<GoogleLoginButton />*/}
          </Form>
        </div>
        <div
          className="w-[50%] h-full rounded-r-[35px] overflow-hidden animate-bg-motion"
          style={{
            backgroundImage: "url('/img/login-side.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
      </div>
    </div>

    // <AuthLayout title={t('forgetPw.title')}>
    //   <Form form={form} layout="vertical" onFinish={onSubmit}>
    //     <Form.Items schema={schema} />
    //     <Button
    //       className="w-full"
    //       loading={loading}
    //       type="primary"
    //       htmlType="submit"
    //     >
    //       {t('forgetPw.sendLink')}
    //     </Button>
    //   </Form>
    // </AuthLayout>
  );
};
